export const onSetCountPageForSearch = (value, onChoiceClick) => {
    if (value <= 5) {
        onChoiceClick(5);
    } else if (10 <= value) {
        onChoiceClick(10);
    } else if (50 <= value) {
        onChoiceClick(50);
    }
}